import React from 'react'
import './header.css'

export default function Header() {
    return (
        <header>
            <h1 className="title">Anim8tor</h1>
        </header>
    )
}


// WEBPACK FOOTER //
// ./src/components/Header.js